export default "__VITE_ASSET__srVam0iM__"